/**
 * NotificationEmptyState — hiç bildirim yok / filtre="okunmamış" ve hepsi okunmuş.
 */
import { Bell, CheckCheck } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

export default function NotificationEmptyState({ filtered = false }) {
  const { t } = useLanguage();
  const Icon = filtered ? CheckCheck : Bell;
  const titleKey = filtered
    ? 'cabin.notifications.empty_filtered.title'
    : 'cabin.notifications.empty.title';
  const subKey = filtered
    ? 'cabin.notifications.empty_filtered.sub'
    : 'cabin.notifications.empty.sub';

  return (
    <div className="flex flex-col items-center gap-3 py-12 px-4 text-center">
      <div className="w-14 h-14 rounded-2xl bg-gray-50 border-2 border-gray-200 flex items-center justify-center">
        <Icon size={24} className="text-gray-400" aria-hidden="true" />
      </div>
      <div>
        <p className="text-sm font-bold text-[var(--text-main)]">{t(titleKey)}</p>
        <p className="text-xs text-[var(--text-secondary)] mt-1 max-w-xs mx-auto">{t(subKey)}</p>
      </div>
    </div>
  );
}
